<template>
  <v-card>
    <div class="d-flex justify-content-between align-items-center mt-3 p-3">
      <div class="title">
        <h1>Penilaian Akademik</h1>
      </div>
    </div>
    <!-- content begin-->
    <KTCodePreview>
      <template v-slot:preview>
        <v-row>
          <v-col>
            <ButtonComponent name="tambah_nilai_akademik" title="Tambah Penilaian Akademik" v-b-modal.penilaian-akademik
              @click.native="openModal('Tambah')" />
          </v-col>
        </v-row>

        <div class="row">
          <div class="col-lg-6">
            <b-form-group label-cols="4" label-cols-lg="4" label="Pilih Matakuliah">
              <SelectComponent :data="matkul" :changeSelected="changeMatkul" Title="" :models="selectedMatkul">
              </SelectComponent>
            </b-form-group>
          </div>
          <div class="col-lg-6">
            <ButtonComponent colors="#17A1FA" name="csv" title="Export Excel" @click.native="$func.exportCsv" />
            <ButtonComponent colors="#3751E4" name="generate" title="GENERATE NILAI" />
          </div>
        </div>

        <v-card-title>
          <v-spacer></v-spacer>
          <v-text-field v-model="code1.search" label="Search" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="code1.headers" :items="code1.desserts" :search="code1.search">
          <template v-slot:item.action="{ item }">
            <ButtonComponent colors="#FFB800" name="lock" @click.native="lockData()" />
            <ButtonComponent colors="#3751E4" name="edit" v-b-modal.penilaian-akademik
              @click.native="openModal('Edit')" />
            <ButtonComponent colors="#EF4848" name="hapus" />
          </template>
        </v-data-table>
      </template>
    </KTCodePreview>

    <b-modal ok-title="Simpan" ok-variant="primary" size="lg" cancel-title="Batal" cancel-variant="danger"
      id="penilaian-akademik" :title="`${statusModal} Nilai Akademik`">
      <b-form>
        <b-table responsive :headers="code1.headers" :items="code1.desserts">
          <template #cell(uts)="data">
            <input type="text" :value="data.value" />
          </template>
          <template #cell(uas)="data">
            <input type="text" :value="data.value" />
          </template>
          <template #cell(praktek)="data">
            <input type="text" :value="data.value" />
          </template>
          <template #cell(tugas)="data">
            <input type="text" :value="data.value" />
          </template>
          <template #cell(kuis)="data">
            <input type="text" :value="data.value" />
          </template>
          <template #cell(diskusi)="data">
            <input type="text" :value="data.value" />
          </template>
        </b-table>
      </b-form>
    </b-modal>
    <!-- content end -->
  </v-card>
</template>

<script>
import KTCodePreview from "@/view/content/CodePreview.vue";
import { directive } from '@coders-tm/vue-number-format'
import ButtonComponent from "@/view/content/components/button/buttonComponent.vue";
import axios from "axios";
import SelectComponent from '@/view/content/components/select/SelectComponent.vue';

export default {
  data() {
    return {
      scoreAcademic: [],
      code1: {
        matkulFilterValue: '',
        search: "",
        headers: [],
        desserts: [],
      },
      code2: {
        search: "",
        headers: [
          { text: "No", value: "no" },
          { text: "NRP", value: "nrp" },
          { text: "Nama", value: "nama" },
          { text: "UTS", value: "uts" },
          { text: "UAS", value: "uas" },
          { text: "Quiz", value: "quiz" },
          { text: "Tugas", value: "tugas" },
        ],
        desserts: [
          {
            no: 1,
            nrp: 1177,
            nama: "ADE TOSHIO FADLY SE",
            uts: 0,
            uas: 0,
            quiz: 0,
            tugas: 0,
          },
          {
            no: 2,
            nrp: 1177,
            nama: "AGUNG NUGROHO",
            uts: 0,
            uas: 0,
            quiz: 0,
            tugas: 0,
          },
          {
            no: 3,
            nrp: 1177,
            nama: "AGUNG PURNOMO ST CMPT",
            uts: 0,
            uas: 0,
            quiz: 0,
            tugas: 0,
          },
          {
            no: 4,
            nrp: 1177,
            nama: "AGUNG SETIYONO SE",
            uts: 0,
            uas: 0,
            quiz: 0,
            tugas: 0,
          },
          {
            no: 5,
            nrp: 1177,
            nama: "AGUNG SUSYANTO ST",
            uts: 0,
            uas: 0,
            quiz: 0,
            tugas: 0,
          },
          {
            no: 6,
            nrp: 1177,
            nama: "AHMAD SUSILO NURHUDA ST",
            uts: 0,
            uas: 0,
            quiz: 0,
            tugas: 0,
          },
          {
            no: 7,
            nrp: 1177,
            nama: "AHMAD SYUKUR ST",
            uts: 0,
            uas: 0,
            quiz: 0,
            tugas: 0,
          },
        ],
      },
      statusModal: '',
      price: 0,
      number: {
        decimal: ',',
        separator: '.',
        prefix: ' ',
        precision: 2,
        masked: false,
      },
      selectedMatkul: '',
      kosong: [],
      matkul: [
        { id: null, text: "--Pilih Matakuliah--" },
      ]
    };
  },
  components: {
    KTCodePreview,
    ButtonComponent,
    SelectComponent,
  },
  directives: {
    number: directive,
  },
  mounted() {
    this.$store.commit('updateCsvName', { name: 'Data Penilaian Akademik', data: this.code1.desserts })

    this.getMatkul();
    this.scoreAcademicFunction();
    this.getDessert();
  },
  methods: {
    changeoption: function (selected) {
      // 
      this.selectedMatkul = selected;
    },
    openModal(status) {
      this.statusModal = status
    },

    async getDessert() {
      const res = await axios.get(`/master/academic-score`);
      // 
      // if (this.code1.desserts.length > 0) {
      //   this.code1.desserts.remove();
      // }
      res.data.data.map((d, index) => {
        // this.desserts.push()
        let dataDessert = {
          no: index + 1,
          nrp: d.nim,
          nama: d.name,
          UTS_0: (d.scoring_list.UTS_0.score) ? d.scoring_list.UTS_0.score : 0,
          UAS_1: (d.scoring_list.UAS_1.score) ? d.scoring_list.UAS_1.score : 0,
          Tugas_2: (d.scoring_list.Tugas_2.score) ? d.scoring_list.Tugas_2.score : 0,
          Praktek_4: (d.scoring_list.Praktek_4.score) ? d.scoring_list.Praktek_4.score : 0,
          // Praktek: (!d.scoring_list.Praktek.score) ? 0 : d.scoring_list.Praktek.score ,
          Kuis_5: (d.scoring_list.Kuis_5.score) ? d.scoring_list.Kuis_5.score : 0,
          ip: 0,
          ipk: 0,
          predikat: "A"
        }
        this.code1.desserts.replace(dataDessert);
      })
      // 
      // res.data.data.map((d, index) => {
      //   
      // d.scoring_list.map((ds, index) => {
      //   
      //   // let dataf = {
      //   //   no: index + 1,
      //   //   nrp: '-',
      //   //   nama: d.name,
      //   // };
      //   // 
      //   let datas = [];
      //   var obj1 = {[ds.comp_name] : ds.score };
      //   // datas.push(obj1);
      //   
      //   if (ds.length > index) {
      //     // 
      //     datas.push(obj1);
      //   }
      //   // 
      //   
      // })
      // })
    },

    async scoreAcademicFunction() {
      await axios.get('master/academic-score-range')
        .then(response => {
          let dash = [
            { text: "No", value: "no" },
            { text: "NRP", value: "nrp" },
            { text: "Nama", value: "nama" },

          ];
          response.data.data.map((e, index) => {

            var object = { "text": e.component, "value": e.component }
            dash.push(object);
            return index > e.length;
          });
          let dash1 = [
            { text: "IP", value: "ip" },
            { text: "IPK", value: "ipk" },
            { text: "Predikat", value: "predikat" },
            { text: "Aksi", value: "action" }
          ]
          dash1.map((f, index1) => {
            var object = { "text": f.text, "value": f.value }
            dash.push(object);
            return index1 > f.length;
          })
          this.code1.headers = dash;
          
        });
    },

    matkulFilter(value) {
      // If this filter has no value we just skip the entire filter.

      return value.includes(this.matkulFilterValue);
    },

    changeMatkul: function (selected) {
      this.selectedMatkul = selected;
      // 
      this.getData();
    },

    async getData() {
      try {
        const result = await axios.get(`master/academic-score/course/${this.selectedMatkul}`)
        // 
        // 
        if (this.code1.desserts.length > 0) {
          this.code1.desserts = [];
        }

        result.data.data.map((d, index) => {
          let dataDessert = {
            no: index + 1,
            nrp: d.nim,
            nama: d.name,
            UTS: (!d.scoring_list.UTS) ? 0 : parseInt(d.scoring_list.UTS.score),
            UAS: (!d.scoring_list.UAS) ? 0 : parseInt(d.scoring_list.UAS.score),
            Tugas: (!d.scoring_list.Tugas) ? 0 : parseInt(d.scoring_list.Tugas.score),
            Praktek: (!d.scoring_list.Praktek) ? 0 : parseInt(d.scoring_list.Praktek.score),
            Diskusi: (!d.scoring_list.Diskusi) ? 0 : parseInt(d.scoring_list.Diskusi.score),
            Kuis: (!d.scoring_list.Kuis) ? 0 : parseInt(d.scoring_list.Kuis.score),
            ip: 0,
            ipk: 0,
            predikat: "A"
          }
          // 
          this.code1.desserts.push(dataDessert);
        })
        // this.code1.desserts = result.data.data;
        
      } catch (err) {
          this.$swal(`Failed`);
      }
    },

    async getMatkul() {
      await axios.get('master/courses')
        .then(response => {
          response.data.data.map((e, index) => {
            var object = { "id": e.key, "text": e.course_name }
            this.matkul.push(object);
            return index > e.length;
          });
        });
    },

    async lockData() {
      try {
        this.$swal({
          text: 'Yakin Menyimpan Nilai ?',
          showCancelButton: true,
          confirmButtonText: 'Ya, Simpan!',
          cancelButtonText: 'Batal!',
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33'
        }).then(async (result) => {
          if (result.value) {
            // User confirmed, so delete the item
            // no action
            this.refreshData(result, 'Delete')
          } else {
            // User canceled, so do nothing
          }
        })
      } catch (err) {
          this.$swal(`Failed`);
      }
    },
  }
}
</script>